import styled from "styled-components";

const LeftSideStyleHolder = styled.div`
    .leftSideContainer {
        height: 100%;
        margin-top: ${props => props.showButtonGoBack ? "25px" : "82px"};
    }
`;

export default LeftSideStyleHolder;